module.exports = require('./core')



/** WEBPACK FOOTER **
 ** ./src/components/core/index.js
 **/